<template>
    <div class="login" onselectstart="return false">
        <div class="ai-background">
            <div class="ai-overlay"></div>
        </div>
        
        <div class="login-container">
            <div class="login-card">
                <div class="logo-area">
                    <div class="logo-text">AI.EEEUY.COM</div>
                    <div class="logo-subtitle">咿呦动画制作平台</div>
                </div>
                
                <!-- 登录表单 -->
                <div v-show="log_in" class="form-area">
                    <div class="form-title">欢迎回来</div>
                    
                    <div class="input-group" v-for="item,index in loginData">
                        <div class="input-icon">
                            <img :src="item.image">
                        </div>
                        <div class="input-field">
                            <input v-if="item.type == 'account'" list="history" type="text" :placeholder="item.title" v-model="login_input_account" v-on:input="handleInputEditing(item)">
                            <datalist id="history">
                                <option v-for="item,index in login_account_history">{{item}}</option>
                            </datalist>
                            
                            <input v-if="item.type == 'password'" :type="password" :placeholder="item.title" v-model="login_input_password" v-on:input="handleInputEditing(item)">
                        </div>
                        <div class="show-password" v-if="item.type == 'password'" @click="passwordSee()">
                            <img src="./register_nosee.png" v-show="!showPassword">
                            <img src="./register_see.png" v-show="showPassword">
                        </div>
                    </div>
                    
                    <div class="forgot-password" v-show="log_in" @click="forgotClick()">忘记密码?</div>
                    
                    <div class="toast" :class="{'success':toast_active}">{{error_info}}</div>
                    
                    <button class="login-button" :class="{'disabled':!login_normarl_status,'active':login_normarl_status}" @click="handleLoginButton()">{{login_title}}</button>
                    
                    <div class="register-link">
                        <span>{{login_text_1}}</span>
                        <a @click="handleText()">{{login_text_2}}</a>
                    </div>
                </div>
                
                <!-- 注册/忘记密码表单 -->
                <div v-show="log_in_register" class="form-area">
                    <div class="form-title">{{ isForgotpwd ? '找回密码' : '创建账号' }}</div>
                    
                    <div class="input-group" v-for="item,index in register_forgot_data">
                        <div class="input-label">{{item.name}}</div>
                        <div class="input-field">
                            <input v-if="item.type == 'account'" type="text" :placeholder="item.title" v-model="login_input_account" v-on:input="handleInputEditing(item)">
                            <input v-if="item.type == 'username'" type="text" :placeholder="item.title" v-model="login_input_username" v-on:input="handleInputEditing(item)">
                            <input v-if="item.type == 'password'" :type="password" :placeholder="item.title" v-model="login_input_password" v-on:input="handleInputEditing(item)">
                            <input v-if="item.type == 'code'" type="text" :placeholder="item.title" v-model="login_input_code" v-on:input="handleInputEditing(item)">
                        </div>
                        <div class="code-button" :class="{'active':canClick,'disabled':!canClick}" v-if="item.name=='验证码:'" @click="sendCode()">{{code_timer_text}}</div>
                        <div class="show-password" v-if="item.type == 'password'" @click="passwordSee()">
                            <img src="./register_nosee.png" v-show="!showPassword">
                            <img src="./register_see.png" v-show="showPassword">
                        </div>
                    </div>
                    
                    <div class="toast" :class="{'success':toast_active}">{{error_info}}</div>
                    
                    <button class="login-button" :class="{'disabled':!login_normarl_status,'active':login_normarl_status}" @click="handleLoginButton()">{{login_title}}</button>
                    
                    <div class="back-to-login" v-show="isForgotpwd || login_type_register" @click="gotoLogin()">返回登录</div>
                    
                    <!-- 注册协议 -->
                    <div class="protocol-area" v-show="login_show_protocol">
                        <span>同意</span>
                        <a v-for="item, index in register_protocol" @click="handleProtocol(item)">{{item.title}}</a>
                    </div>
                </div>
            </div>
            
            <div class="features-area">
                <div class="feature-item">
                    <div class="feature-icon">🚀</div>
                    <div class="feature-title">AI智能创作</div>
                    <div class="feature-desc">自研模型库，多种动画风格可选</div>
                </div>
                <div class="feature-item">
                    <div class="feature-icon">🎨</div>
                    <div class="feature-title">丰富的素材库</div>
                    <div class="feature-desc">动作库一键套用，形象库一键制作</div>
                </div>
                <div class="feature-item">
                    <div class="feature-icon">🔄</div>
                    <div class="feature-title">云端创作</div>
                    <div class="feature-desc">随时随地，创作你的作品</div>
                </div>
            </div>
        </div>
        
        <div class="loading-mask" v-show="mask_visible">
            <div v-loading="loading" v-show="loading" element-loading-background="rgba(0,0,0,0.5)" class="loading-spinner"></div>
        </div>
        
    </div>
</template>

<script>
  // 通讯协议
  import Protocol from '@/common/scripts/protocol.js'
  // 公共方法
  import EUY from '@/common/scripts/euy'
  
  export default {
    components: {

    },
    data () {
      return {
        loginData:[{'type':'account', 'title':'请输入手机号／Email','image':require('./login_email.png')}, {'type':'password', 'title':'请输入密码','image':require('./login_password.png')}],
        login_title:'登录',
        login_text_1:'还没有帐号?',
        login_text_2:'立即注册',
        // 登陆类型 false：直接登陆 true：注册/忘记密码
        login_type_register:false,
        // 错误信息
        error_info:'',
        login_input_account:'',
        login_input_username:'',
        login_input_password:'',
        login_normarl_status:false,
        // 注册timer
        login_code_timer:null,
        totalTime:60,
        canClick:true,
        code_timer_text:'发送验证码',
        // 注册时发送的验证码
        login_input_code:'',
        // 协议
        register_protocol:[{'title':'《用户协议、隐私政策》',  'url':'http://a2.eeeuy.com/passport/services/copyright'},
                          ],
        //  显示注册协议
        login_show_protocol:false,
        register_code_count:0,
        // 注册的类型 手机／邮箱
        register_type:'',
        // 显示登陆界面
        log_in:true,
        // 显示注册／忘记密码界面
        log_in_register:false,
        // // 显示登陆界面
        // log_in_forgot:true,
        register_forgot_data: [{'type':'account',  'title':'请输入手机号', 'name':'账   号:'},
                               {'type':'code',  'title':'请输入收到的验证码', 'name':'验证码:'},
                               {'type':'username', 'title':'请输入昵称3-20个字','name':'昵   称:'},
                               {'type':'password', 'title':'请输入密码',        'name':'密   码:'}],
        // 忘记密码
        isForgotpwd:false,
        // 显示遮罩
        mask_visible:false,
        loading:false,
        password:'password',
        showPassword:false,

        // 登录的用户信息
        userinfo: {
            nickname: '',
            avatarInfo: '',
            gid: '',
        },

        token:'',
        token_timer:'',
        toast_active:false,
        // 重连次数
        heart_reconnect_count:0,
        token_heart_timer:'',
        login_account_history:[],

        platform: this.$route.query.platform,
      }
    },

    computed: {
        // inputState(){

        // }
    },

    created (){
        let component = this
        document.onkeydown = function (e){
        // console.log('document.onkeydown ======= >' + component.login_title)
            let key = window.event.keyCode
            if(key == 13){
                component.handleLoginButton()
            }

        }
    },

    methods: {
        handleText(){
            this.login_type_register = !this.login_type_register

            if(this.login_type_register){

                // 注册
                this.login_title  = '注册'
                this.login_text_1 = '已有帐号?'
                this.login_text_2 = '立即登录'
                this.register_forgot_data = [{'type':'account',  'title':'请输入手机号', 'name':'账   号:'},
                                             {'type':'code',  'title':'请输入收到的验证码', 'name':'验证码:'},
                                             {'type':'username', 'title':'请输入昵称3-20个字','name':'昵   称:'},
                                             {'type':'password', 'title':'请输入密码',        'name':'密  码:'}]
                this.login_show_protocol = true
                this.log_in = false
                this.log_in_register = true
                this.isForgotpwd = false

            }else {
                // 登陆
                this.login_title  = '登录'
                this.login_text_1 = '还没有帐号?'
                this.login_text_2 = '立即注册'
                this.login_show_protocol = false
                this.log_in = true
                this.log_in_register = false
            }

                // 清空timer
                window.clearInterval(this.login_code_timer)
                this.code_timer_text = '发送验证码'
                this.totalTime = 60
                this.canClick = true
                this.login_input_account = ''
                this.login_input_username = ''
                this.login_input_password = ''
                this.login_input_code = ''
                this.login_normarl_status = false
                this.error_info = ''
                this.showPassword = false
                this.password = 'password'
                this.toast_active = false
        },

        // 登陆／注册/找回密码 点击
        handleLoginButton(){
            // 手机邮箱验证
            var phoneReg = 11 && /^((11|12|13|14|15|16|17|18|19)[0-9]{1}\d{8})$/;
            var emailReg = /^([a-zA-Z0-9]+[_|\-|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\-|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
            let isPhone = phoneReg.test(this.login_input_account)
            let isEmail = emailReg.test(this.login_input_account)

            // 1 校验账号
            if(this.login_input_account.length == 0){
                this.error_info = '账号不能为空'
                return
            }

            // 2 校验验证码
            if(this.log_in_register){
                if(this.login_input_code.length <= 0){
                    this.error_info = '请输入验证码'
                    return
                }else if(this.login_input_code.length < 6){
                    this.error_info = '验证码少于6位'
                    return
                }
            }

            if(this.login_title == '注册'){
                if(isPhone){
                    this.register_type = 'mobile'
                }else {
                    this.error_info = '请输入手机号'
                    return
                }
                // 2 校验昵称
                if(this.login_input_username.length <= 0){
                    this.error_info = '昵称不能为空'
                    return
                }else if(this.login_input_username.length < 3 || this.login_input_username.length > 20){
                    this.error_info = '昵称3-20个字'
                    return
                }else if (this.login_input_username.indexOf('@') >= 0 ){
                    this.error_info = '昵称不能含有@'
                    return
                }else if (this.login_input_username.indexOf(' ') >= 0 ){
                    this.error_info = '昵称不能含有空格'
                    return
                }
                // 3 校验密码
                if(this.login_input_password.length < 6){
                    this.error_info = '密码至少6位'
                    return
                }

                // 显示验证码页面
                this.error_info = ''
                this.handleRegister(this.register_type)

            }else if(this.login_title == '登录'){
                if(isPhone){
                    this.register_type = 'mobile'
                }else  if(isEmail){
                    this.register_type = 'email'
                }else {
                    this.error_info = '请输入手机号/邮箱'
                    return
                }
                // 判断密码
                if(this.login_input_password.length < 6){
                    this.error_info = '密码少于6位'
                    return
                }
                this.error_info = ''
                this.handleLogin()
            }else if(this.login_title == '重置密码'){
                if(isPhone){
                    this.register_type = 'mobile'
                }else  if(isEmail){
                    this.register_type = 'email'
                }else {
                    this.error_info = '请输入手机号/邮箱'
                    return
                }
                // 3 校验密码
                if(this.login_input_password.length < 6){
                    this.error_info = '密码至少6位'
                    return
                }
                this.handleForgotPassword(this.register_type)
            }

            // 不显示注册协议
            this.login_show_protocol = false
            this.error_info = ''
        },

        // 直接登陆
        gotoLogin(){
            this.reset()
            this.login_title  = '登录'
            this.login_text_1 = '还没有帐号?'
            this.login_text_2 = '立即注册'
            this.login_show_protocol = false
            this.log_in = true
            this.log_in_register = false
            this.toast_active = false
        },
        //
        handleInputEditing(item){

            let account = this.login_input_account.length > 0
            let username = this.login_input_username.length >= 3 && this.login_input_username.length <= 20
            let password = this.login_input_password.length >= 6
            let code = this.login_input_code && this.login_input_code.length >=6

            if(this.log_in){
                if( account && password){
                    this.login_normarl_status = true
                }else{
                    this.login_normarl_status = false
                }
            }else if(this.log_in_register){
                if(this.isForgotpwd){
                    if(account && password && code){
                        this.login_normarl_status = true
                    }else{
                        this.login_normarl_status = false
                    }
                }else{
                    if(account && username && password && code){
                        this.login_normarl_status = true
                    }else{
                        this.login_normarl_status = false
                    }
                }

            }
        },

        //  登陆
        handleLogin(){
            this.error_info = ''
            if(!this.login_type_register){
                let URL = process.env.HOST + '/passport/login'
                let password = this.$md5(this.login_input_password)
                let token = this.token
                let params = 'tokenId=' + token + '&regionCode=' + '0086' + '&loginName=' + this.login_input_account + '&password=' + password
                let headers = {
                    'token': token,
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                }
                // console.log('---------- 0' + URL + JSON.stringify(params) + JSON.stringify(headers))
                this.loading = true
                this.mask_visible = true
                this.AJAX.post(URL, headers, params).then((data)=>{
                    // console.log('---------- 1' + JSON.stringify(data))
                    this.loading = false
                    this.mask_visible = false
                    if(data.code == '0'){
                        this.gotoHomepage(data)
                    }else if(data.code == '220202'){
                        this.error_info = "账号与密码不是一对儿 (>﹏<)"
                    }else {
                        this.error_info = data.msg
                    }
                }).catch((err)=>{
                    // console.log('---------- 2' + JSON.stringify(err))
                    this.loading = false
                    this.mask_visible = false
                    if(err.code == '220202'){
                        this.error_info = "账号与密码不是一对儿 (>﹏<)"
                    }else{
                        this.error_info = err.msg
                    }

                })
            }

        },

        //  完成注册点击
        handleRegister(type){
            let url = (type == 'mobile')?'/passport/mobile/simpleRegister':'/passport/email/simpleRegister'
            let URL = process.env.HOST + url
            let password = this.login_input_password
            let token = this.token
            let params = ''
            if(type == 'mobile'){
                params = 'tokenId=' + token + '&regionCode=' + '0086' + '&mobile=' + this.login_input_account + '&password=' + password + '&nickname=' + this.login_input_username + '&authcode=' + this.login_input_code
            }else if (type == 'email'){
                params = 'tokenId=' + token + '&regionCode=' + '0086' + '&email=' + this.login_input_account + '&password=' + password + '&nickname=' + this.login_input_username + '&authcode=' + this.login_input_code
            }

            let headers = {
                'token': token,
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            }

            // console.log('handleRegister ---------- 0' + URL + JSON.stringify(params) + JSON.stringify(headers) + type)
            this.loading = true
            this.mask_visible = true
            this.AJAX.post(URL, headers, params).then((data)=>{
                // console.log('handleRegister ---------- 1' + JSON.stringify(data))
                this.loading = false
                this.mask_visible = false
                if(data.code == '0'){
                    this.error_info = '注册成功'
                    this.gotoHomepage(data)
                }
            }).catch((err)=>{
                // console.log('handleRegister ---------- 2' + JSON.stringify(err))
                this.loading = false
                this.mask_visible = false
                this.error_info = err.msg
            })
        },

        // 忘记密码
        handleForgotPassword(type){
            let url = (type == 'mobile')?'/passport/mobile/forgetpwd':'/passport/email/forgetpwd'
            let URL = process.env.HOST + url
            let password = this.login_input_password
            let token = this.token
            let params = ''
            if(type == 'mobile'){
                params = 'tokenId=' + token + '&regionCode=' + '0086' + '&mobile=' + this.login_input_account + '&password=' + password + '&authcode=' + this.login_input_code
            }else if (type == 'email'){
                params = 'tokenId=' + token + '&regionCode=' + '0086' + '&email=' + this.login_input_account + '&password=' + password + '&authcode=' + this.login_input_code
            }

            let headers = {
                'token': token,
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            }

            // console.log('handleForgotPassword ---------- 0' + URL + JSON.stringify(params) + JSON.stringify(headers))
            this.loading = true
            this.mask_visible = true
            this.AJAX.post(URL, headers, params).then((data)=>{
                // console.log('handleForgotPassword ---------- 1' + JSON.stringify(data))
                this.loading = false
                this.mask_visible = false
                if(data.code == '0'){
                    this.toast_active = true
                    this.error_info = '修改密码成功'
                    setTimeout(() => {
                        this.reset()
                    }, 1000);

                }
            }).catch((err)=>{
                // console.log('handleForgotPassword ---------- 2' + JSON.stringify(err))
                this.loading = false
                this.mask_visible = false
                this.error_info = err.msg
            })
        },

        // 忘记密码点击
        forgotClick(){
            this.reset()
            this.isForgotpwd = true
            this.log_in = false
            this.log_in_register = true
            this.login_title = '重置密码'
            this.register_forgot_data = [{'type':'account',  'title':'请输入手机号／Email', 'name':'账   号:'},
                                         {'type':'code',     'title':'请输入收到的验证码', 'name':'验证码:'},
                                         {'type':'password', 'title':'请输入新密码',        'name':'新密码:'}]

        },
        // 显示密码
        passwordSee(){
            this.showPassword = !this.showPassword
            this.password = this.showPassword ? 'text' : 'password'
        },
        // 获取验证码
        sendCode(){
            if(this.login_input_account.length == 0){
                this.error_info = '请输入手机号/邮箱'
                return
            }else{
                // 手机邮箱验证
                var phoneReg = 11 && /^((11|12|13|14|15|16|17|18|19)[0-9]{1}\d{8})$/;
                var emailReg = /^([a-zA-Z0-9]+[_|\-|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\-|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
                let isPhone = phoneReg.test(this.login_input_account)
                let isEmail =  emailReg.test(this.login_input_account)

                if(this.login_title == '注册'){
                    if(isPhone){
                        this.register_type = 'mobile'
                    }else {
                        this.error_info = '请输入手机号'
                        return
                    }
                }else{
                    if(isPhone){
                        this.register_type = 'mobile'
                    }else  if(isEmail){
                        this.register_type = 'email'
                    }else {
                        this.error_info = '请输入手机号/邮箱'
                        return
                    }
                }
            }
            this.error_info = ''
            if(!this.canClick) return
            this.canClick = false
            this.register_code_count++
            this.code_timer_text = '重发' +'('+ 60 +')'
            this.login_code_timer = window.setInterval(() =>{
                this.totalTime--
                this.code_timer_text = '重发' +'('+ this.totalTime +')'
                if(this.totalTime < 0){
                    window.clearInterval(this.login_code_timer)
                    this.code_timer_text = '发送验证码'
                    this.totalTime = 60
                    this.canClick = true
                }
            },1000)

            this.error_info = ''
            // 注册还是找回密码
            let codetype = this.isForgotpwd?'3':'1'
            let url = (this.register_type == 'mobile')?'/passport/mobile/sendAuthcode':'/passport/email/sendAuthcode'
            let URL = process.env.HOST + url
            let password = this.login_input_password
            let token = this.token
            let params = ''

            if(this.register_type == 'mobile'){
                params = 'tokenId=' + token + '&regionCode=' + '0086' + '&mobile=' + this.login_input_account + '&type=' + codetype + '&tryNum=' + this.register_code_count
            }else if (this.register_type == 'email'){
                params = 'tokenId=' + token + '&regionCode=' + '0086' + '&email=' + this.login_input_account + '&type=' + codetype + '&tryNum=' + this.register_code_count
            }

            let headers = {
                'token': token,
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            }

            // console.log('sendCode ---------- 0' + URL + JSON.stringify(params) + JSON.stringify(headers) + 'ffff =')
            this.AJAX.post(URL, headers, params).then((data)=>{
                // console.log('sendCode ---------- 1' + JSON.stringify(data))
            }).catch((err)=>{
                // console.log('sendCode ---------- 2' + JSON.stringify(err))
                if(err.code == '220501'){
                    this.error_info = '今天与验证码约会超过6次了，被拖走……'
                }else if(err.code == '220502'){
                    this.error_info = '验证码发送失败'
                }else{
                    this.error_info = err.msg
                }

            })
        },

        // 注册／登录成功后跳转到homepage
        gotoHomepage(data){

            this.userinfo = {
                'nickname': data.result.baseInfo.nickname,
                'avatarInfo':data.result.avatarInfo.small,
                'gid': data.result.baseInfo.gid,
            }
            EUY.SetStorage('userinfo', this.userinfo)
            let login_status = {
                                'tokenId': this.token,
                                'exkey': data.result.exkey,
                                'oid': data.result.oid,
                                }
            EUY.SetStorage('login_status',login_status)
            this.$router.push('/homepage');
            this.handleTokenHeart()

            // 将输入的账号保存起来
            let login_account = []
            let history = EUY.GetStorage('login_account')
            if(history != ''){
                for(var i = 0;i < history.length;i++){
                    login_account.push(history[i])
                }
            }

            let exist = false
            for(var i = 0;i<login_account.length;i++){
                if(login_account[i] == this.login_input_account){
                    exist = true
                }
            }
            if(!exist){
                login_account.push(this.login_input_account)
            }
            EUY.SetStorage('login_account',login_account)
            // console.log('this.userinfo == ' + JSON.stringify(login_account))

            this.reset()
        },
        // 注册的相关协议
        handleProtocol(item){
            const newWindow = window.open(item.url)
        },

        reset(){
            this.login_title  = '登录'
            this.login_text_1 = '还没有帐号?'
            this.login_text_2 = '立即注册'
            this.error_info = ''
            this.login_type_register = false
            this.login_input_account = ''
            this.login_input_username = ''
            this.login_input_password = ''
            window.clearInterval(this.login_code_timer)
            this.code_timer_text = '发送验证码'
            this.totalTime = 60
            this.canClick = true
            this.login_input_code = ''
            this.login_normarl_status = false
            this.register_done = false
            this.login_show_protocol = false
            this.register_type = ''
            this.log_in = true
            this.log_in_register = false
            this.isForgotpwd = false
            this.mask_visible = false
            this.loading = false
            this.showPassword = false
            this.password = 'password'
            this.toast_active = false
        },

        handleToken(){
            clearInterval(this.token_timer)
            let URL = process.env.HOST + '/passport/tokenId'
            let params = 'platform=web' + '&id=com.eeeuy.pro' + '&version=v1.1' + '&channel=eeeuy.com'
            let headers = {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            }
            // {"code":220102,"msg":"TokenID is empty","result":{"loginType":null}}
            console.log("handleTokenURL=" + URL);
            this.AJAX.post(URL, headers, params).then((data)=>{
                if(data.code == '0'){
                    this.token = data.result.tokenId
                    window.clearInterval(this.token_timer)
                    // console.log('token --- ' + data.result.tokenId)
                    // 自动登录
                    let exkey = EUY.GetStorage('login_status').exkey
                    if(exkey){
                        let url = process.env.HOST + '/passport/exkey'
                        // 需要将+转译
                        exkey = exkey.replace(/\+/g,'%2B')
                        let param = 'tokenId=' + this.token + '&exkey=' + exkey
                        this.AJAX.post(url, headers, param).then((response)=>{
                            console.log('auto login s===== >' + JSON.stringify(response))
                            if(data.code == '0'){
                               this.gotoHomepage(response)
                            }
                        }).catch((error)=>{
                            console.log('auto login e===== >' + JSON.stringify(error))
                        })
                    }
                }
            }).catch((err)=>{
                this.token_timer = window.setInterval(() =>{
                    this.handleToken()
                },5000)
            })
        },

        handleTokenHeart(){
            clearInterval(this.token_heart_timer)
            // token 心跳
            let _this = this
            let URL = process.env.HOST + '/api/a2/passport/heartbeat'
            let token = EUY.GetStorage('login_status').tokenId
            let exkey = EUY.GetStorage('login_status').exkey
            let params = 'tokenId=' + token
            let headers = {
                'token': token,
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            }
            // console.log('---------- 0' + URL + JSON.stringify(params) + JSON.stringify(headers))
            this.AJAX.post(URL, headers, params).then((data)=>{
                // console.log('---------- handleGetUserInfo => login' + JSON.stringify(data))
                if(data.code == '0'){
                    _this.userinfo = {
                                    'nickname': data.result.baseInfo.nickname,
                                    'avatarInfo':data.result.avatarInfo.small,
                                    'gid': data.result.baseInfo.gid,
                                }
                    EUY.SetStorage('userinfo', this.userinfo)
                    _this.login_status = {
                                    'tokenId': data.result.tokenId,
                                    'exkey': exkey,
                                    'oid': data.result.oid,
                                }
                    EUY.SetStorage('login_status',_this.login_status)
                    _this.heart_reconnect_count = 0
                    let token_heart_time = 1000 * 60 * 7
                    this.token_heart_timer = setInterval(() =>{
                        _this.handleTokenHeart()
                    },token_heart_time)
                }else{
                    setTimeout(() => {
                        _this.handleTokenHeart()
                    }, 5000);
                }
            }).catch((err)=>{
                _this.heart_reconnect_count ++
                if(_this.heart_reconnect_count > 5){
                    EUY.RemoveStorage('share')
                    EUY.RemoveStorage('editor_url')
                    EUY.RemoveStorage('login_status')
                    EUY.RemoveStorage('tabs')
                    EUY.RemoveStorage('currentTab')
                    EUY.RemoveStorage('team_info')
                    EUY.RemoveStorage('userinfo')
                    _this.heart_reconnect_count = 0
                    location = '/login';
                }else{
                    setTimeout(() => {
                        _this.handleTokenHeart()
                    }, 5000);
                }
                // console.log('---------- handleGetUserInfo ---------- 2' + JSON.stringify(err))

                })
        },
    },
    mounted () {
        this.handleToken()
        // 获取账号记录
        let _this = this
        _this.login_account_history = EUY.GetStorage('login_account')
    },

    watch: {
        // 账号
      'login_input_account':function(){
          // ^A-Za-z0-9\.\@\-\_\,\;]/g

        this.login_input_account = this.login_input_account.replace(/[^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,6}$]/g, "")
      },
    //   'login_input_username':function(){
    //     this.login_input_username = this.login_input_username.replace(/[^A-Za-z0-9\.\u4e00-\u9fa5\_]/g, "")
    //   },
       // 密码
      'login_input_password':function(){
        this.login_input_password = this.login_input_password.replace(/\s+/g, "")
      },
        // 注册验证码
      'login_input_code':function(){
        this.login_input_code = this.login_input_code.replace(/[^0-9]/g, "")
      },

    },
  }
</script>
<style scoped>
 ::-webkit-input-placeholder { /* placeloder 字体颜色 */
    color: rgba(255,255,255,0.6);
    font-size: 14px;
  }
  .white-space{
    white-space:pre
  }

</style>

<style lang="stylus" scoped>
  .login
    top: 0
    left: 0
    bottom: 0
    right: 0
    position: absolute
    display: flex
    align-items: center
    justify-content: center
    overflow: hidden
    font-family: 'Helvetica Neue', Arial, sans-serif
    
    .ai-background
      position: absolute
      top: 0
      left: 0
      right: 0
      bottom: 0
      background-image: url('./background.jpeg')
      background-size: cover
      background-position: center
      z-index: 0
      
      &:before
        content: ''
        position: absolute
        top: 0
        left: 0
        right: 0
        bottom: 0
        background: linear-gradient(135deg, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.3) 100%)
        z-index: 1
      
      .ai-overlay
        position: absolute
        top: 0
        left: 0
        right: 0
        bottom: 0
        background: radial-gradient(circle at center, rgba(66,133,244,0.1) 0%, rgba(66,133,244,0) 70%)
        z-index: 2
        animation: pulse 8s infinite ease-in-out
    
    .login-container
      position: relative
      display: flex
      width: 80%
      max-width: 1200px
      height: 600px
      background: rgba(15,23,42,0.7)
      border-radius: 20px
      box-shadow: 0 20px 50px rgba(0,0,0,0.3)
      overflow: hidden
      backdrop-filter: blur(10px)
      z-index: 10
      
      .login-card
        flex: 1
        padding: 40px
        display: flex
        flex-direction: column
        
        .logo-area
          margin-bottom: 30px
          text-align: center
          
          .logo-text
            font-size: 32px
            font-weight: bold
            color: #fff
            letter-spacing: 1px
            margin-bottom: 5px
            background: linear-gradient(90deg, #4285F4, #34A853, #FBBC05, #EA4335)
            -webkit-background-clip: text
            -webkit-text-fill-color: transparent
            
          .logo-subtitle
            font-size: 16px
            color: rgba(255,255,255,0.7)
        
        .form-area
          flex: 1
          display: flex
          flex-direction: column
          
          .form-title
            font-size: 24px
            font-weight: 500
            color: #fff
            margin-bottom: 30px
            text-align: center
          
          .input-group
            position: relative
            margin-bottom: 20px
            display: flex
            align-items: center
            box-sizing: border-box
            width: 100%
            
            .input-icon
              width: 24px
              height: 24px
              margin-right: 10px
              display: flex
              align-items: center
              justify-content: center
              
              img
                width: 18px
                height: 18px
                opacity: 0.8
            
            .input-label
              width: 80px
              color: rgba(255,255,255,0.9)
              font-size: 14px
            
            .input-field
              flex: 1
              max-width: calc(100% - 34px) /* 减去图标宽度(24px)和右边距(10px) */
              box-sizing: border-box
              
              input
                width: 100%
                height: 40px
                background: rgba(255,255,255,0.1)
                border: none
                border-radius: 8px
                padding: 0 15px
                color: #fff
                font-size: 14px
                transition: all 0.3s
                box-sizing: border-box
                
                &:focus
                  outline: none
                  background: rgba(255,255,255,0.15)
                  box-shadow: 0 0 0 2px rgba(66,133,244,0.3)
            
            .show-password
              position: absolute
              right: 15px
              top: 50%
              transform: translateY(-50%)
              width: 20px
              height: 20px
              cursor: pointer
              
              img
                width: 100%
                height: 100%
            
            .code-button
              position: absolute
              right: 10px
              top: 50%
              transform: translateY(-50%)
              height: 30px
              padding: 0 10px
              background: rgba(66,133,244,0.8)
              color: #fff
              border: none
              border-radius: 4px
              font-size: 12px
              cursor: pointer
              display: flex
              align-items: center
              justify-content: center
              transition: all 0.3s
              
              &.disabled
                background: rgba(100,100,100,0.5)
                cursor: not-allowed
          
          .forgot-password
            align-self: flex-end
            color: rgba(255,255,255,0.7)
            font-size: 14px
            margin-bottom: 20px
            cursor: pointer
            transition: all 0.3s
            
            &:hover
              color: #4285F4
          
          .toast
            height: 20px
            color: #ff4f52
            font-size: 14px
            margin-bottom: 20px
            text-align: center
            
            &.success
              color: #34A853
          
          .login-button
            height: 50px
            width: 100%
            box-sizing: border-box
            background: linear-gradient(90deg, #4285F4, #34A853)
            border: none
            border-radius: 8px
            color: #fff
            font-size: 16px
            font-weight: 500
            cursor: pointer
            transition: all 0.3s
            margin-bottom: 20px
            
            &:hover
              background: linear-gradient(90deg, #5294FF, #45B964)
              box-shadow: 0 4px 12px rgba(66,133,244,0.3)
            
            &.disabled
              background: rgba(100,100,100,0.5)
              cursor: not-allowed
          
          .register-link
            text-align: center
            font-size: 14px
            color: rgba(255,255,255,0.7)
            
            a
              color: #4285F4
              margin-left: 5px
              cursor: pointer
              transition: all 0.3s
              
              &:hover
                text-decoration: underline
          
          .back-to-login
            text-align: center
            font-size: 14px
            color: #4285F4
            margin-top: 10px
            cursor: pointer
            transition: all 0.3s
            
            &:hover
              text-decoration: underline
          
          .protocol-area
            text-align: center
            font-size: 12px
            color: rgba(255,255,255,0.6)
            margin-top: 20px
            
            a
              color: #4285F4
              margin-left: 5px
              cursor: pointer
              
              &:hover
                text-decoration: underline
      
      .features-area
        width: 40%
        padding: 40px
        background: rgba(15,23,42,0.5)
        display: flex
        flex-direction: column
        justify-content: center
        position: relative
        overflow: hidden
        
        &:before
          content: ''
          position: absolute
          top: 0
          left: 0
          right: 0
          bottom: 0
          background: linear-gradient(135deg, rgba(66,133,244,0.1) 0%, rgba(52,168,83,0.1) 100%)
          z-index: -1
        
        .feature-item
          margin-bottom: 40px
          position: relative
          padding-left: 20px
          
          &:before
            content: ''
            position: absolute
            left: 0
            top: 0
            bottom: 0
            width: 3px
            background: linear-gradient(to bottom, #4285F4, #34A853)
            border-radius: 3px
          
          .feature-icon
            font-size: 28px
            margin-bottom: 10px
          
          .feature-title
            font-size: 18px
            font-weight: 500
            color: #fff
            margin-bottom: 10px
          
          .feature-desc
            font-size: 14px
            color: rgba(255,255,255,0.7)
            line-height: 1.5
    
    .loading-mask
      position: fixed
      top: 0
      left: 0
      right: 0
      bottom: 0
      background: rgba(0,0,0,0.7)
      z-index: 100
      display: flex
      align-items: center
      justify-content: center
      
      .loading-spinner
        width: 100px
        height: 100px

  @keyframes pulse
    0%
      opacity: 0.5
      transform: scale(1)
    50%
      opacity: 1
      transform: scale(1.05)
    100%
      opacity: 0.5
      transform: scale(1)
</style>



// WEBPACK FOOTER //
// Login.vue?228f1ea1